
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-home-gear-line',
      title: 'Refinances',
      description: 'Access to private lending solutions for harder-to-place mortgages. Get the financing you need, even when traditional lenders say no.',
      features: ['Private lending access', 'Competitive rates', 'Fast approvals']
    },
    {
      icon: 'ri-stack-line',
      title: 'Debt Consolidations',
      description: 'Simplify your finances by combining multiple debts into one manageable payment with potentially lower interest rates.',
      features: ['Lower monthly payments', 'Single payment', 'Improved cash flow']
    },
    {
      icon: 'ri-bank-card-line',
      title: 'Home Equity Line of Credit (HELOC)',
      description: 'Unlock the equity in your home for renovations, investments, or major purchases with flexible access to funds.',
      features: ['Flexible access', 'Competitive rates', 'Tax advantages']
    }
  ];
  
  return (
    <section className="py-20 bg-dark-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Mortgage Solutions <span className="text-red-400">Tailored for You</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            With 25 years of experience and Level 2 certification, I provide comprehensive 
            mortgage services across Ontario, specializing in complex financing solutions.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-dark-800 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-dark-700 hover:border-red-400/50"
            >
              <div className="w-16 h-16 bg-red-900/30 rounded-xl flex items-center justify-center mb-6 group-hover:bg-red-600 transition-colors duration-300">
                <i className={`${service.icon} text-3xl text-red-400 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-red-400 transition-colors duration-300">
                {service.title}
              </h3>
              
              <p className="text-gray-300 mb-6 leading-relaxed">
                {service.description}
              </p>
              
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-400">
                    <i className="ri-check-line text-red-400 mr-2 w-4 h-4 flex items-center justify-center"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        {/* Refinance Link */}
        <div className="text-center mt-12">
          <Link
            to="/refinance-options"
            className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold transition-colors whitespace-nowrap"
          >
            Learn about refinancing benefits
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
